import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

/**
 *
 * Product Count Spline chart
 */
const AtlasV2SalesProductCountSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      fieldName="stacklineSku"
      indexName="sales"
      title="Product Count"
      primaryAggregationBuilder={(aggregationBuilder) => aggregationBuilder.addConditionRangeFilter('unitsSold', 4)}
    />
  );
};

export default AtlasV2SalesProductCountSplineChart;
